(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apple-collection"] && !Shopify.designMode) return;
  try {
    
  if(window.matchMedia('(max-width: 900px)').matches){document.querySelectorAll('.oa-filter').forEach(function(filter){filter.removeAttribute('open')})}
  document.addEventListener('change',function(event){if(event.target.matches('#OaFilters select[name="sort_by"]'))event.target.form.submit()})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apple-product"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var section=document.querySelector('.oa-product');
    var form=document.getElementById('OaProductForm');
    var data=document.getElementById('OaVariants');
    if(!form||!data)return;
    var variants=JSON.parse(data.textContent);
    var selects=Array.from(form.querySelectorAll('.oa-option-select'));
    var idInput=document.getElementById('OaVariantId');
    var price=document.getElementById('OaPrice');
    var availability=document.getElementById('OaAvailability');
    var button=document.getElementById('OaAddButton');
    var valueMessage=document.getElementById('OaValueMessage');
    function money(cents){return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:'USD'}).format(cents/100)}
    function showImage(src,alt,mediaId){
      var main=document.getElementById('OaMainImage');
      if(!main||!src)return;
      main.src=src;
      main.removeAttribute('srcset');
      main.alt=alt||main.alt;
      document.querySelectorAll('.oa-product__thumb').forEach(function(item){
        var active=mediaId&&item.dataset.mediaId===String(mediaId);
        item.classList.toggle('is-active',active);
        item.setAttribute('aria-pressed',active?'true':'false');
      });
    }
    function updateVariant(){
      var choices=selects.map(function(select){return select.value});
      var variant=variants.find(function(item){return item.options.every(function(value,index){return value===choices[index]})});
      if(!variant){idInput.value='';button.disabled=true;availability.textContent=section.dataset.unavailableLabel;return}
      idInput.value=String(variant.id);
      idInput.setAttribute('value',String(variant.id));
      price.textContent=money(variant.price);
      button.disabled=!variant.available;
      button.textContent=variant.available?section.dataset.addLabel:section.dataset.soldLabel;
      availability.textContent=variant.available?section.dataset.readyLabel:section.dataset.soldLabel;
      var quantity=choices.join(' ');
      valueMessage.textContent=quantity.indexOf('20,000')>-1||quantity.indexOf('1,000')>-1?section.dataset.bulkValue:section.dataset.packValue;
      if(variant.featured_media&&variant.featured_media.preview_image){
        showImage(variant.featured_media.preview_image.src,variant.featured_media.alt,variant.featured_media.id);
      }
      window.history.replaceState({},'',window.location.pathname+'?variant='+variant.id);
    }
    selects.forEach(function(select){select.addEventListener('change',updateVariant)});
    form.addEventListener('submit',updateVariant,true);
    document.querySelectorAll('.oa-product__thumb').forEach(function(thumb){
      thumb.addEventListener('click',function(){
        showImage(thumb.dataset.imageSrc,thumb.dataset.imageAlt,thumb.dataset.mediaId);
      });
    });
    updateVariant();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
